/**
 * @file index.tsx
 * @module app/modules/reports/index
 * @description Implements the index interface for operational reporting.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import SelectReportType from './selectReportType';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
const reportsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Reports',
    path: '/reports',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          index
          element={<Navigate to="/reports/" />}
        />
        <Route
          path="/index"
          element={
            <>
              <PageTitle>
                Reports
              </PageTitle>
              <SelectReportType />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default index;
